export default __webpack_public_path__ + "assets/7003387b9e6a440a0e01f8ccd80f6be9.pdf";